// Product card image carousel (collection grids).
// Native scroll-snap for swiping; a clone of the last slide is put first and a clone of the
// first slide last, so when a clone settles we jump to the real slide and the carousel loops.
if (!customElements.get("product-card-carousel")) {
  class ProductCardCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.track = this.querySelector("[data-carousel-track]");
      if (!this.track) return;

      this.count = this.track.children.length;
      if (this.count < 2) return;

      this.initialized = true;

      const first = this.track.firstElementChild;
      const last = this.track.lastElementChild;
      const firstClone = first.cloneNode(true);
      const lastClone = last.cloneNode(true);
      [firstClone, lastClone].forEach(function (clone) {
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("data-clone", "");
      });
      this.track.appendChild(firstClone);
      this.track.insertBefore(lastClone, first);

      this.index = 1;
      this.jumpTo(1);

      this.onScrollEnd = this.onScrollEnd.bind(this);
      if ("onscrollend" in window) {
        this.track.addEventListener("scrollend", this.onScrollEnd);
      } else {
        this.track.addEventListener(
          "scroll",
          function () {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(this.onScrollEnd, 120);
          }.bind(this),
          { passive: true }
        );
      }

      const prev = this.querySelector("[data-carousel-prev]");
      const next = this.querySelector("[data-carousel-next]");
      if (prev) prev.addEventListener("click", this.onArrow.bind(this, -1));
      if (next) next.addEventListener("click", this.onArrow.bind(this, 1));

      // Keep the current slide in place when the card width changes
      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(
          function () {
            this.jumpTo(this.index);
          }.bind(this)
        );
        this.resizeObserver.observe(this.track);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    get slideWidth() {
      return this.track.clientWidth || 1;
    }

    currentIndex() {
      return Math.round(this.track.scrollLeft / this.slideWidth);
    }

    jumpTo(index) {
      this.index = index;
      this.track.scrollTo({ left: index * this.slideWidth, behavior: "instant" });
    }

    // Track positions: 0 = clone of last, 1..count = real slides, count + 1 = clone of first
    normalize() {
      const index = this.currentIndex();
      if (index <= 0) {
        this.jumpTo(this.count);
      } else if (index >= this.count + 1) {
        this.jumpTo(1);
      } else {
        this.index = index;
      }
    }

    onScrollEnd() {
      this.normalize();
    }

    onArrow(direction, event) {
      event.preventDefault();
      event.stopPropagation();
      this.normalize();
      this.index = this.index + direction;
      const start = this.track.scrollLeft;
      const target = this.index;
      this.track.scrollTo({ left: target * this.slideWidth, behavior: "smooth" });

      // Some browsers skip smooth scrolling entirely; jump instead so the arrow still works
      setTimeout(
        function () {
          if (this.track.scrollLeft === start && this.index === target) {
            this.jumpTo(target);
            this.normalize();
          }
        }.bind(this),
        250
      );
    }
  }

  customElements.define("product-card-carousel", ProductCardCarousel);
}
